import React, { useEffect, useRef } from "react";
import { Stage as PixiStage } from "@pixi/react";
import { ReactReduxContext } from "react-redux";
import { DimensionsContext } from "./Contexts/DimensionsContext";
import { FreeSpinAnimationContext } from "./Contexts/FreeSpinAnimationContext";
import { AppActivityContext } from "./Contexts/AppActivityContext";
import { ReelControlContext } from "./Contexts/ReelControlContext";
import { FreeSpinControlContext } from "./Contexts/FreeSpinControlContext";
import { HoldAndWinControlContext } from "./Contexts/HoldAndWinControlContext";
import { useDimensions } from "./Contexts/DimensionsContext";
import ContextBridge from "./Contexts/ContextBridge";
import BackgroundAnimation from "./Components/Animations/BackgroundAnimation/BackgroundAnimation";
import ExpirationPopup from "./Components/UserInterface/primary/Popups/ExpirationPopup";
// import Menu from "./Components/UserInterface/primary/Menu/Menu";
import IntroPopup from "./Components/UserInterface/shared/Popups/IntroPopup/IntroPopup/IntroPopup";
import IntroTransitionOverlay from "./Components/Animations/IntroTransitionOverlay/IntroTransitionOverlay";
import SceneTransitionOverlay from "./Components/Animations/SceneTransitionOverlay/SceneTransitionOverlay";
import GameContainer from "./Games/Main/GameContainer/GameContainer";
import WinAnimation from "./Components/Animations/WinAnimation/WinAnimation";
import Dialogs from "./Components/Animations/Dialogs/Dialogs";
import { ReelRefsContext } from "./Contexts/ReelRefsContext";
import HookImport from "./Hooks/HookImport";
import Loader from "./Components/UserInterface/secondary/Popups/Loader";
import { useSelector } from "react-redux";
import UserInterface from "./Components/UserInterface/secondary/UserInterface";
import HoldAndWinReloadDialog from "./Components/Animations/HoldAndWinReloadDialog/HoldAndWinReloadDialog";

const StageWithDimensions = ({ children }) => {
  const { dimensions } = useDimensions();
  const stageRef = useRef(null);

  useEffect(() => {
    if (stageRef.current) {
      const app = stageRef.current.app;
      globalThis.__PIXI_APP__ = app;
      globalThis.__PIXI_STAGE__ = app.stage;
      globalThis.__PIXI_RENDERER__ = app.renderer;
      globalThis.__PIXI_STAGE__.name = "stage";
      globalThis.__PIXI_STAGE__.sortableChildren = true;
    }
  }, []);

  return (
    <ContextBridge
      contexts={[
        { Context: ReelRefsContext },
        { Context: ReactReduxContext },
        { Context: AppActivityContext },
        { Context: DimensionsContext },
        { Context: FreeSpinAnimationContext },
        { Context: ReelControlContext },
        { Context: FreeSpinControlContext },
        { Context: HoldAndWinControlContext },
      ]}
      render={(bridgeChildren) => (
        <PixiStage
          ref={stageRef}
          width={dimensions.width}
          height={dimensions.height}
          options={{
            resolution: window.devicePixelRatio || 2,
            autoDensity: true,
            backgroundColor: 0x000000,
            antialias: true,
            powerPreference: "high-performance",
            preserveDrawingBuffer: false,
            clearBeforeRender: true,
          }}
          name="stage"
        >
          {bridgeChildren}
        </PixiStage>
      )}
    >
      {children}
    </ContextBridge>
  );
};

const Stage = () => {
  const { status } = useSelector((state) => state.loadingProgress);

  return (
    <>
      <StageWithDimensions>
        <HookImport />

        <Loader />

        {/* Show game content once assets are loaded */}
        {status === "success" && (
          <>
            <BackgroundAnimation />

            <IntroPopup renderMode="spine" />

            <HoldAndWinReloadDialog />

            <IntroTransitionOverlay />

            <SceneTransitionOverlay />

            <UserInterface>
              <GameContainer />
            </UserInterface>

            {/* <Menu /> */}

            <Dialogs />

            <WinAnimation />

            <ExpirationPopup />
          </>
        )}
      </StageWithDimensions>
    </>
  );
};

export default Stage;
